export const CMS_API = import.meta.env.VITE_CMS_API || 'https://cmspub.asbjornenge.com'

export function formatDate(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  return d.toLocaleDateString('nb-NO', { year: 'numeric', month: 'long', day: 'numeric' })
}

export function buildExcerpt(blocks, max = 180) {
  if (!Array.isArray(blocks)) return ''
  const firstPara = blocks.find(b => b.type === 'paragraph' && b.text?.trim())
  if (!firstPara) return ''
  let text = firstPara.text.replace(/\[\d+\]/g, '').replace(/\s+/g, ' ').trim()
  if (text.length > max) {
    const cut = text.slice(0, max)
    const lastSpace = cut.lastIndexOf(' ')
    text = (lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut) + '…'
  }
  return text
}

export function readingTime(blocks) {
  if (!Array.isArray(blocks)) return 0
  const words = blocks.reduce((n, b) => n + (b.text ? b.text.trim().split(/\s+/).length : 0), 0)
  return Math.max(1, Math.round(words / 200))
}

export function getPreviewImage(post) {
  return post.preview_image
    || post.layout?.images?.[0]
    || post.layout?.breakpoints?.find(bp => bp.images?.length)?.images?.[0]
    || null
}

const SITE_URL = 'https://xn--bllefr-mxa1y.no' // bøllefrø.no punycode

export function setMeta({ title, description, image, type = 'article', url }) {
  if (title) document.title = title.includes('Bøllefrø') ? title : `${title} — Bøllefrø`
  setMetaTag('description', description)
  setMetaTag('og:title', title ? `${title} — Bøllefrø` : null, true)
  setMetaTag('og:description', description, true)
  setMetaTag('og:image', image || `${SITE_URL}/og-image.png`, true)
  setMetaTag('og:type', type, true)
  setMetaTag('og:url', url, true)
}

function setMetaTag(name, content, og = false) {
  if (!content) return
  const attr = og ? 'property' : 'name'
  let el = document.head.querySelector(`meta[${attr}="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export function resetMeta() {
  setMeta({
    title: 'Bøllefrø',
    description: 'Spesialkaffe fra Sandnes — bøller med stil.',
  })
}
